<mat-form-field
  [style.fontSize]="'12px'"
  class="w-full {{ searchFieldClasses }}"
  [ngClass]="{ 'border-bottom': searchFieldAppearance === 'standard' }"
  [appearance]="searchFieldAppearance"
>
  <mat-label>{{ searchLabel }}</mat-label>
  <input
    [placeholder]="searchPlaceholder"
    autocomplete="off"
    matInput
    id="searchInput"
    [formControl]="searchCtrl"
    data-test="y42-list-view-input-search-entity"
  />
  <div matPrefix>
    <fa-icon [icon]="['fal', 'search']" class="mr-1 relative text-gray-700"></fa-icon>
  </div>
  <div matSuffix *ngIf="searchCtrl.value" class="relative">
    <button
      class="small-icon-button"
      mat-icon-button
      (click)="searchCtrl.reset('')"
      data-test="list-view-input-search-entity-clear-search"
    >
      <fa-icon class="fs-8" [icon]="['fal', 'times']"></fa-icon>
    </button>
  </div>
</mat-form-field>
